module.exports = __webpack_public_path__ + "5da7e7d413dcd1506814d248dcb11cf0.pdf";